import React, { useEffect, useState } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import classNames from 'classnames';

import { LANDING_PAGE_VIEWS, PHONE_TEL_INPUT } from '@shared/config/constants/app';
import { getCountryPlaceholder } from '@entities/country/model/placeholders';
import { isVariationV3Route } from '@shared/utils/general';
import { LogService } from '@shared/services/LogService';
import { CountryData } from 'react-intl-tel-input/dist/types';
import { useAtomValue } from 'jotai';
import { dcbAtom, globalAtom } from '@shared/store/slice-atoms';

interface Props {
  phone: string;
  handlePhoneChange: (
    isValid: boolean,
    value: string,
    selectedCountryData: CountryData,
    fullNumber: string,
    extension: string
  ) => void;
  preferredCountries: Array<string>;
  showCountryDropdown: boolean;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  hideCountryFlag: boolean;
  placeholder?: string;
  classname?: string;
}

export const TelInput: React.FC<Props> = ({
  phone,
  handlePhoneChange,
  preferredCountries,
  showCountryDropdown,
  setSelectedCountry,
  hideCountryFlag,
  placeholder = '',
  classname = '',
}) => {
  const dcb = useAtomValue(dcbAtom);
  const { landingPageView } = useAtomValue(globalAtom);
  const isV3Route = isVariationV3Route(dcb.variationKey);
  const homeData = dcb.homeData;
  const operatorSelectedDetails = dcb.operatorSelectedDetails;

  const [_phone, setPhone] = useState<string>('');

  useEffect(() => {
    // NOTE: we need this trick cause of this https://360mea.atlassian.net/browse/VAS-2486
    // NOTE: when user goes back IntlTelInput does not get rendered cause in their code there is an update of state depending on value and isabled status
    setPhone(phone);

    return () => {
      setPhone('');
    };
  }, [phone]);

  const getTelInputClassName = () => {
    if (isV3Route) {
      return `intl-tel-input`;
    }

    return `${hideCountryFlag ? 'intl-tel-input-2' : null} intl-tel-input ${
      showCountryDropdown ? 'dropdown' : ''
    }`;
  };

  const handleBlurPhone = () => {
    LogService.dcbSelectMsisdn(phone);
  };

  const isV3PhoneNumberView = landingPageView === LANDING_PAGE_VIEWS.PHONE_NUMBER;

  const inputPlaceholder =
    placeholder ||
    operatorSelectedDetails?.countryPlaceholder ||
    // @ts-ignore
    homeData?.countryPlaceholder ||
    getCountryPlaceholder(preferredCountries[0]);

  return (
    <IntlTelInput
      containerClassName={classNames(getTelInputClassName(), classname)}
      preferredCountries={preferredCountries}
      defaultCountry={preferredCountries[0]}
      format={false}
      formatOnInit={false}
      fieldId={PHONE_TEL_INPUT}
      value={_phone}
      onPhoneNumberChange={handlePhoneChange}
      separateDialCode
      allowDropdown={!isV3PhoneNumberView ? showCountryDropdown : false}
      placeholder={inputPlaceholder}
      onPhoneNumberBlur={handleBlurPhone}
      onSelectFlag={(num, country) => setSelectedCountry(country.iso2 || '')}
    />
  );
};
